import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useMemo, useRef, useState } from "react";
import { useEffect } from "react";
import { pageScrollStyle } from "../../../styles/styles";
import DataTable from "../../../components/DataTable";
import TeamsImg from "../../../assets/sign-up-law.webp";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { backend_api } from "../../../static/server";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { LoadingButton } from "@mui/lab";
import { getAllRoles, getAllUsers } from "../../../redux/Apps/users/userSlice";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import { AddRounded, CloseRounded } from "@mui/icons-material";
import { getCases } from "../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import {
  handleMatterNewTab,
  ListboxComponent,
  NoDataOptionField,
} from "../../../static/staticdata";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import noOption from "../../../assets/no-option-found.webp";
import { useNavigate } from "react-router-dom";
import { getAllTask } from "../../../redux/Apps/Lawyerapp/TaskSlice/TaskSlice";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import CustomRoleDrawer from "../../../components/LawyerCompo/Team/CustomRoleDrawer";
import { useDialog } from "../../../components/DialogContext";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CustomNoRowsOverlay = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      p: "2rem",
      gap: "1rem",
    }}
  >
    <Box sx={{ height: "9rem" }}>
      <img
        src={TeamsImg}
        alt="Team Img"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = require("../../../assets/no-preview.webp");
        }}
      />
    </Box>
    <Typography variant="body1">No team member available.</Typography>
  </Box>
);

const CustomToolbar = () => {
  return (
    <GridToolbarContainer className="flex justify-end px-2 py-2">
      <div className="flex gap-2">
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </div>
    </GridToolbarContainer>
  );
};

const sections = {
  profileRole: {
    title: "Profile Role",
    options: ["Attorney", "Non-Attorney"],
    type: "radio",
  },
  accessRole: {
    title: "Access Role",
    options: ["Administrator", "Accounts", "Reports", "Billing"],
    type: "checkbox",
  },
};

const TeamPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  const [moreMenu, setMoreMenu] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDeleteRoleDialog, setOpenDeleteRoleDialog] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoad, setDeleteLoad] = useState(false);
  const [openReAssigneWork, setOpenReAssignWork] = useState(false);
  const [openDeactivate, setOpenDeactivate] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [anchorRoleAdd, setAnchorRoleAdd] = useState(null);
  const [expandedSection, setExpandedSection] = useState(null);
  const [page, setPage] = useState(1);
  const contentRefs = {
    userRole: useRef(null),
    accessRole: useRef(null),
  };
  const [customRoleDrawer, setCustomRoleDrawer] = useState(false);
  const { token, allUsers, allRoles, loading, error } = useSelector(
    (state) => state.user
  );
  const { allTask } = useSelector((state) => state.task);

  const { pageSize, rowCount, nextPage, previousPage, count } = useSelector(
    (state) => state.user.userPagination
  );

  const { allCase, loading: caseLoading } = useSelector((state) => state.case);

  useEffect(() => {
    dispatch(getCases({ url: `${backend_api}case/register/`, token: token }));
    dispatch(
      getAllUsers({ url: `${backend_api}team/create-employee/`, token: token })
    );
    dispatch(
      getAllTask({
        url: `${backend_api}task/task-register/`,
        token: token,
      })
    );
    dispatch(
      getAllRoles({
        page: 1,
        token: token,
      })
    );
  }, [dispatch, token]);

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      profileRole: [],
      accessRole: [],
      customRole: [],
    },
  });

  const onSubmit = (data) => {
    console.log("Selected Roles:", data);
  };

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleMenuOpen = (event) => {
    setMoreMenu(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMoreMenu(null);
  };

  const handleMoreAction = (action, id) => {
    handleMenuClose();
    if (action === "re_assign_work") {
      setOpenReAssignWork(true);
    } else if (action === "deactivate") {
      setOpenDeactivate(true);
    } else if (action === "change_password") {
      setOpenChangePassword(true);
    }
  };

  const handleEditUser = (id) => {
    console.log(id);
  };
  const handleEditRole = (id) => {
    console.log(id);
  };
  const handleDeleteDialog = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };
  const handleDeleteRoleDialog = (id) => {
    setRoleId(id);
    setOpenDeleteRoleDialog(true);
  };
  const handleDeleteUser = async (id) => {
    setDeleteLoad(true);
    try {
      await axios.delete(`${backend_api}team/create-employee/${id}/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      toast.success("User deleted successfully");
      dispatch(
        getAllUsers({
          url: `${backend_api}team/create-employee/`,
          token: token,
        })
      );
    } catch (error) {
      toast.error("Failed to delete user. Please try again.");
    } finally {
      setDeleteLoad(false);
      setOpenDeleteDialog(false);
    }
  };
  const handleDeleteRole = async (id) => {
    setDeleteLoad(true);
    try {
      await axios.delete(`${backend_api}lawer/user-access/${id}/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      toast.success("Role deleted successfully");
      dispatch(
        getAllRoles({
          url: `${backend_api}lawer/user-access/`,
          token: token,
        })
      );
    } catch (error) {
      toast.error("Failed to delete role. Please try again.");
    } finally {
      setDeleteLoad(false);
      setOpenDeleteRoleDialog(false);
    }
  };
  const handlePageChange = (newPage) => {
    dispatch(
      getAllUsers({
        url: nextPage,
        token: token,
        page: newPage,
        pageSize: pageSize,
      })
    );
  };

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      headerAlign: "left",
      renderCell: (item) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "0.2rem",
            width: "100%",
          }}
        >
          <Tooltip title="Edit">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEditUser(item.id)}
            >
              <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleDeleteDialog(item.id)}
            >
              <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          {/* More Menu */}
          <Tooltip title="More">
            <IconButton color="primary" size="small" onClick={handleMenuOpen}>
              <MoreVertRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          {/* Menu Items */}
          <Menu
            anchorEl={moreMenu}
            open={Boolean(moreMenu)}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => handleMoreAction("re_assign_work", item.id)}
            >
              Reassign work
            </MenuItem>
            <MenuItem onClick={() => handleMoreAction("deactivate", item.id)}>
              Deactivate
            </MenuItem>
            <MenuItem onClick={() => handleMoreAction("change_password")}>
              Change Password
            </MenuItem>
          </Menu>
        </Box>
      ),
    },
    { field: "full_name", headerName: "Full Name", width: 200 },
    { field: "email", headerName: "Email", width: 250 },
    {
      field: "role",
      headerName: "Role",
      width: 250,
      renderCell: (item) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              flex: 1,
            }}
          >
            {Array.isArray(item?.row?.role) && item.row.role.length > 0 ? (
              item.row.role.map((role, index) => (
                <Chip
                  key={index}
                  label={role}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                -
              </Typography>
            )}
          </Box>
          <Tooltip title="Update Role">
            <IconButton
              size="small"
              onClick={(e) => setAnchorRoleAdd(e.currentTarget)}
            >
              <ManageAccountsRoundedIcon sx={{ fontSize: "1.2rem" }} />
            </IconButton>
          </Tooltip>

          <Menu
            anchorEl={anchorRoleAdd}
            open={Boolean(anchorRoleAdd)}
            onClose={() => setAnchorRoleAdd(null)}
            slotProps={{
              paper: {
                elevation: 0,
                sx: {
                  maxHeight: "15rem",
                  overflow: "auto",
                  "& .MuiList-root": {
                    p: 0,
                  },
                  "&::-webkit-scrollbar": {
                    width: "0.4rem",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(0,0,0,0.2)",
                    borderRadius: "4px",
                  },
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "center" }}
            anchorOrigin={{ horizontal: "left", vertical: "center" }}
          >
            <Box sx={{ width: "16rem" }}>
              {Object.entries(sections).map(
                ([sectionKey, { title, options, type }]) => (
                  <Box key={sectionKey}>
                    <Box
                      onClick={() => toggleSection(sectionKey)}
                      sx={{
                        px: 1.5,
                        py: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        transition: "background-color 0.2s ease",
                        "&:hover": {
                          bgcolor: "action.hover",
                        },
                      }}
                    >
                      <Typography variant="body2" fontWeight={500}>
                        {title}
                      </Typography>
                      <IconButton
                        size="small"
                        sx={{
                          p: 0,
                          transform:
                            expandedSection === sectionKey
                              ? "rotate(0deg)"
                              : "rotate(-90deg)",
                          transition: "transform 0.3s ease",
                        }}
                      >
                        {expandedSection === sectionKey ? (
                          <KeyboardArrowDownRoundedIcon fontSize="small" />
                        ) : (
                          <KeyboardArrowRightRoundedIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Box>

                    <Box
                      ref={contentRefs[sectionKey]}
                      sx={{
                        height:
                          expandedSection === sectionKey
                            ? `${contentRefs[sectionKey]?.current?.scrollHeight}px`
                            : "0px",
                        opacity: expandedSection === sectionKey ? 1 : 0,
                        overflow: "hidden",
                        transition: "all 0.3s ease-in-out",
                        px: 1.5,
                        "& .MuiFormControlLabel-root": {
                          transform:
                            expandedSection === sectionKey
                              ? "translateX(0)"
                              : "translateX(-10px)",
                          opacity: expandedSection === sectionKey ? 1 : 0,
                          transition: "all 0.3s ease-in-out",
                          "&:nth-of-type(1)": { transitionDelay: "0.1s" },
                          "&:nth-of-type(2)": { transitionDelay: "0.15s" },
                          "&:nth-of-type(3)": { transitionDelay: "0.2s" },
                          "&:nth-of-type(4)": { transitionDelay: "0.25s" },
                        },
                      }}
                    >
                      {options.map((option) => (
                        <Controller
                          key={option}
                          name={sectionKey}
                          control={control}
                          render={({ field }) => (
                            <FormControlLabel
                              control={
                                type === "radio" ? (
                                  <Checkbox
                                    {...field}
                                    checked={field?.value === option}
                                    onChange={(e) =>
                                      field.onChange(
                                        e.target.checked ? option : null
                                      )
                                    }
                                    size="small"
                                  />
                                ) : (
                                  <Checkbox
                                    {...field}
                                    checked={
                                      field?.value?.includes(option) || false
                                    }
                                    onChange={(e) => {
                                      const currentValues = field?.value || [];
                                      if (e.target.checked) {
                                        field.onChange([
                                          ...currentValues,
                                          option,
                                        ]);
                                      } else {
                                        field.onChange(
                                          currentValues.filter(
                                            (val) => val !== option
                                          )
                                        );
                                      }
                                    }}
                                    size="small"
                                  />
                                )
                              }
                              label={
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {option}
                                </Typography>
                              }
                            />
                          )}
                        />
                      ))}
                    </Box>
                    <Divider
                      sx={{
                        opacity: expandedSection === sectionKey ? 1 : 0.5,
                        transition: "opacity 0.3s ease",
                      }}
                    />
                  </Box>
                )
              )}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  p: "0.4rem",
                }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setCustomRoleDrawer(true);
                    setAnchorRoleAdd(null);
                  }}
                  sx={{
                    textTransform: "none",
                    transition: "transform 0.2s ease",
                    "&:hover": {
                      transform: "translateX(2px)",
                    },
                  }}
                >
                  Custom Role
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // Call the form submission handler directly
                    const formData = {
                      profileRole: watch("profileRole"),
                      accessRole: watch("accessRole"),
                      customRole: watch("customRole"),
                    };
                    onSubmit(formData);
                    setAnchorRoleAdd(null);
                  }}
                  sx={{
                    fontSize: "0.8rem",
                    textTransform: "none",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      transform: "translateY(-1px)",
                      boxShadow: 2,
                    },
                  }}
                >
                  Set Role
                </Button>
              </Box>
            </Box>
          </Menu>
        </Box>
      ),
    },
    { field: "billrate", headerName: "Bill Rate", width: 120 },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      renderCell: (item) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.2rem",
            width: "100%",
          }}
        >
          {item?.value ? (
            <Typography
              variant="body1"
              color="#4CAF50"
              sx={{
                textAlign: "center",
                fontSize: "0.9rem",
                fontWeight: 500,
                px: "1rem",
                borderRadius: "1rem",
                backgroundColor: "#f0f0f0",
                border: "1px solid",
                borderColor: "#4CAF50",
              }}
            >
              Active
            </Typography>
          ) : (
            <Typography
              variant="body1"
              color="#F44336"
              sx={{
                textAlign: "center",
                fontSize: "0.8rem",
                width: "4rem",
                fontWeight: 500,
                px: "0.2rem",
                borderRadius: "1rem",
                backgroundColor: "#f0f0f0",
                border: "1px solid",
                borderColor: "#4CAF50",
              }}
            >
              Not Active
            </Typography>
          )}
        </Box>
      ),
    },
  ];
  const roleColumns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      headerAlign: "left",
      renderCell: (item) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "0.2rem",
            width: "100%",
          }}
        >
          <Tooltip title="Edit">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleEditRole(item.id)}
            >
              <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleDeleteRoleDialog(item.id)}
            >
              <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          {/* More Menu */}
          <Tooltip title="More">
            <IconButton color="primary" size="small" onClick={handleMenuOpen}>
              <MoreVertRoundedIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </Tooltip>

          {/* Menu Items */}
          <Menu
            anchorEl={moreMenu}
            open={Boolean(moreMenu)}
            onClose={handleMenuClose}
          >
            <MenuItem
              onClick={() => handleMoreAction("re_assign_work", item.id)}
            >
              Reassign work
            </MenuItem>
            <MenuItem onClick={() => handleMoreAction("deactivate", item.id)}>
              Deactivate
            </MenuItem>
            <MenuItem onClick={() => handleMoreAction("change_password")}>
              Change Password
            </MenuItem>
          </Menu>
        </Box>
      ),
    },
    { field: "role_name", headerName: "Role Name", width: 200 },
    { field: "description", headerName: "Description", width: 250, flex: 1 },
  ];

  const rows = useMemo(() => {
    if (!Array.isArray(allUsers)) {
      console.error("allUsers is not an array:", allUsers);
      return [];
    }

    return allUsers.map((item) => ({
      id: item?.id ?? "-",
      full_name: item?.first_name
        ? item?.last_name
          ? `${item?.first_name} ${item?.last_name}`
          : item?.first_name
        : "-",
      email: item?.reminder_mail ?? "-",
      role: Array.isArray(item?.access)
        ? item.access.map((role) => role?.role_name ?? "-")
        : [],
      billrate: item?.hourly_rate ?? "-",
      status: item?.is_active ?? "-",
    }));
  }, [allUsers]);

  const roleRows = useMemo(() => {
    if (!Array.isArray(allRoles)) {
      console.error("allRoles is not an array:", allRoles);
      return [];
    }

    return allRoles?.map((item) => ({
      id: item?.id ?? "-",
      role_name: item?.role_name ?? "-",
      description: item?.description ?? "-",
    }));
  }, [allRoles]);
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: "1rem",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "0.5rem",
                p: "0.2rem",
                borderRadius: "0.5rem",
                border: "1px solid #e5e5e5",
              }}
            >
              <Button
                variant={tab === 1 ? "contained" : "text"}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "0.8rem",
                  transition: "all 0.2s",
                }}
                size="small"
                onClick={() => setTab(1)}
              >
                Users
              </Button>
              <Button
                variant={tab === 2 ? "contained" : "text"}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "0.8rem",
                  transition: "all 0.2s",
                }}
                size="small"
                onClick={() => setTab(2)}
              >
                Roles
              </Button>
            </Box>
            {tab === 2 && (
              <Button
                variant="outlined"
                sx={{
                  textTransform: "capitalize",
                  fontSize: "0.8rem",
                  transition: "all 0.2s",
                }}
                size="small"
                onClick={() => setCustomRoleDrawer(true)}
              >
                New Role
              </Button>
            )}
          </Box>
          <Box>
            {tab === 1 ? (
              <DataTable
                columns={columns}
                rows={rows}
                CustomToolbar={CustomToolbar}
                CustomNoRowsOverlay={CustomNoRowsOverlay}
                loading={loading}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                rowCount={rowCount}
              />
            ) : (
              <DataTable
                columns={roleColumns}
                rows={roleRows}
                CustomToolbar={CustomToolbar}
                CustomNoRowsOverlay={CustomNoRowsOverlay}
                loading={loading}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                rowCount={rowCount}
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* --------------------------- DELETE USER CONFOMATION DIALOG HERE --------------------------- */}
      <Dialog
        open={openDeleteDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Sure you want to delete this user</DialogTitle>
        <DialogActions>
          <Button size="small" variant="outlined" color="primary">
            Edit
          </Button>

          {deleteLoad ? (
            <LoadingButton size="small" loading variant="contained">
              Delete
            </LoadingButton>
          ) : (
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={() => handleDeleteUser(deleteId)}
            >
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* ------------------------------ DELETE ROLE CONFORMATION DIALOG HERE ---------------------------- */}
      <Dialog
        open={openDeleteRoleDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setOpenDeleteRoleDialog(false)}
      >
        <DialogTitle>Sure you want to delete this Role</DialogTitle>
        <DialogActions>
          <Button size="small" variant="outlined" color="primary">
            Edit
          </Button>

          {deleteLoad ? (
            <LoadingButton size="small" loading variant="contained">
              Delete
            </LoadingButton>
          ) : (
            <Button
              size="small"
              variant="contained"
              color="error"
              onClick={() => handleDeleteRole(roleId)}
            >
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* ------------------------------ MORE ACTION MULTY DIALOG HERE --------------------------- */}
      <Dialog
        open={openReAssigneWork || openDeactivate || openChangePassword}
        TransitionComponent={Transition}
        onClose={() =>
          setOpenReAssignWork(false) ||
          setOpenDeactivate(false) ||
          setOpenChangePassword(false)
        }
        PaperProps={{
          style: {
            padding: 0,
            width: "40rem",
          },
        }}
        sx={{
          "& .MuiDialog-paper": { ...pageScrollStyle },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: "1rem",
            py: "0.5rem",
            bgcolor:
              openDeactivate || openChangePassword
                ? "danger.main"
                : "primary.main",
            position: "sticky",
            top: "0rem",
            left: "0rem",
            zIndex: 9,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              gap: "0.5rem",
            }}
          >
            <Typography
              variant="body1"
              color="white.main"
              sx={{ fontSize: "1rem" }}
            >
              {openReAssigneWork
                ? "Reassign work "
                : openDeactivate
                ? `Deactivate user name`
                : openChangePassword
                ? "Change password of user name"
                : null}
            </Typography>
          </Box>
          <IconButton
            edge="start"
            color="white"
            aria-label="close"
            onClick={() =>
              setOpenReAssignWork(false) ||
              setOpenDeactivate(false) ||
              setOpenChangePassword(false)
            }
          >
            <CloseRounded />
          </IconButton>
        </Box>
        <Box>
          {openReAssigneWork ? (
            <Box sx={{ width: "100%", p: "1rem" }}>
              <from>
                <Box
                  sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
                >
                  <Box>
                    <Controller
                      name="case"
                      control={control}
                      render={({ field }) => (
                        <FormControl
                          size="small"
                          fullWidth
                          error={errors?.case}
                        >
                          <Autocomplete
                            {...field}
                            options={allCase || []}
                            getOptionLabel={(option) => {
                              if (!option) return "";
                              const caseId = option.id ? `000${option.id}` : "";
                              const caseName = option.case_name || "";
                              return caseId && caseName
                                ? `${caseId}-${caseName}`
                                : "";
                            }}
                            value={
                              field.value
                                ? allCase?.find(
                                    (item) => item.id === field.value
                                  )
                                : null
                            }
                            onChange={(_, newValue) =>
                              field.onChange(newValue?.id || null)
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Matter"
                                size="small"
                              />
                            )}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography>
                                    {option.id
                                      ? `000${option.id}-${option.case_name}`
                                      : ""}
                                  </Typography>
                                  <Typography
                                    variant="body1"
                                    sx={{
                                      p: "0.2rem 0.5rem",
                                      borderRadius: "1rem",
                                      textAlign: "center",
                                      fontSize: "0.7rem",
                                      bgcolor:
                                        option?.case_status === "open"
                                          ? "#4CAF50"
                                          : option?.case_status === "pending"
                                          ? "#FFC107"
                                          : "#F44336",
                                      color: "#fff",
                                    }}
                                  >
                                    {option?.case_status}
                                  </Typography>
                                </Box>
                              </li>
                            )}
                            ListboxComponent={(props) => (
                              <ListboxComponent
                                {...props}
                                btnIcon={<ArrowOutwardRoundedIcon />}
                                btnText="Add Matter"
                                handleClikListBtn={handleMatterNewTab}
                              />
                            )}
                            noOptionsText={
                              <NoDataOptionField
                                imgSrc={noOption}
                                text="No matters found"
                                btnText="Matter"
                                handleClickNoData={() =>
                                  navigate("/dashboard/matter")
                                }
                              />
                            }
                          />
                        </FormControl>
                      )}
                    />
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Controller
                      name="tasks"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <Autocomplete
                          multiple
                          size="small"
                          options={allTask || []}
                          getOptionLabel={(option) => option?.task_name || "-"}
                          value={
                            field?.value?.map((id) =>
                              allTask?.find((task) => task.id === id)
                            ) || []
                          }
                          onChange={(_, newValue) => {
                            field.onChange(newValue.map((task) => task?.id));
                          }}
                          isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                          }
                          renderTags={(tagValues, getTagProps) => (
                            <Box
                              sx={{
                                display: "flex",
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                maxHeight: "2.4rem",
                                maxWidth: "20rem",
                              }}
                            >
                              {tagValues?.map((option, index) => (
                                <Chip
                                  size="small"
                                  key={option?.id}
                                  label={option?.task_name}
                                  {...getTagProps({ index })}
                                />
                              ))}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={
                                <span>
                                  Tasks <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              placeholder="Select tasks"
                            />
                          )}
                          ListboxComponent={(props) => (
                            <ListboxComponent
                              {...props}
                              btnIcon={<AddRounded />}
                              btnText="Add Task"
                              handleClikListBtn={() =>
                                navigate("/dashboard/tasks")
                              }
                            />
                          )}
                          noOptionsText={
                            <NoDataOptionField
                              imgSrc={noOption}
                              text={"Oops! No Task to display."}
                              btnText={"Task"}
                              handleClickNoData={() =>
                                navigate("/dashboard/tasks")
                              }
                            />
                          }
                        />
                      )}
                    />
                  </Box>
                </Box>
              </from>
            </Box>
          ) : openDeactivate ? (
            <Box sx={{ width: "100%", p: "1rem" }}>deactivate</Box>
          ) : openChangePassword ? (
            <Box sx={{ width: "100%", p: "1rem" }}>changeBox</Box>
          ) : null}
        </Box>
      </Dialog>

      {/* ---------------------------   ADD CUSTOM ROLE DRAWER HERE ---------------- */}
      <CustomRoleDrawer
        open={customRoleDrawer}
        onClose={() => setCustomRoleDrawer(false)}
      />
    </Box>
  );
};

export default TeamPage;
